const $ = require("jquery");

export function site() {


    let items = document.querySelectorAll('.carousel .carousel-item')

    items.forEach((el) => {
        const minPerSlide = 3
        let next = el.nextElementSibling
        for (var i = 1; i < minPerSlide; i++) {
            if (!next) {
                // wrap carousel by using first child
                next = items[0]
            }
            let cloneChild = next.cloneNode(true)
            el.appendChild(cloneChild.children[0])
            next = next.nextElementSibling
        }
    })

    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            $('#btnScroll').fadeIn();
        } else {
            $('#btnScroll').fadeOut();
        }
    });

    var modalEls = document.getElementsByClassName('modal video-modal');
    Array.prototype.forEach.call(modalEls, function (el) {

        var $iframeArr = el.getElementsByTagName('iframe');
        if ($iframeArr.length > 0) {
            var iframe = $iframeArr[0];

            el.addEventListener('show.bs.modal', function (event) {
                iframe.setAttribute("src", iframe.dataset.src);
            });

            el.addEventListener('hidden.bs.modal', function (event) {
                iframe.removeAttribute("src");
            });
        }
    });

    document.addEventListener('DOMContentLoaded', function () {

        var splides = document.getElementsByClassName('splide');

        for (var i = 0; i < splides.length; i++) {
            var carousel = new Splide(splides[i]);
            carousel.mount();            
        }

        $('.splide__pagination').each(function () {
            var allSlides = $(this).closest('.splide').find('.splide__slide:not(.splide__slide--clone)');

            if (allSlides.length > 1) {
                var $splideControls = $(this).siblings('.splide_controls');
                if ($splideControls.length > 0) {
                    $('.inner', $splideControls[0]).append($(this));
                }

                $(this).closest('.page-section').addClass('with-splide-controls');

            } else {
                $(this).closest('.splide').addClass('no-pagination');
                $(this).hide();
                $(this).closest('.splide').find('.splide_controls').addClass('d-none');
            }
        });

        $('.splide__pagination__page.is-active').each(function () {
            var $that = $(this);
            $that.removeClass('is-active');

            setTimeout(function () {
                $that.addClass('is-active');
            });
        });

    });

    const $mobileNavRoot = $('#mobileNavFirstLevel');

    $(function () {
        $(".mobile-nav-toggler").on("click", function (a) {
            $mobileNavRoot.addClass("open");
            a.stopPropagation()
        });       
    });

    $(".btn-close", $mobileNavRoot).on("click", function (a) {
        $mobileNavRoot.removeClass("open");
    });

    $('.nav-link.go-back', $mobileNavRoot).click(function () {
        $(this).closest('.navigation-column').removeClass('active');
    });


    $('.nav-link[data-type="section"]', $mobileNavRoot).click(function (e) {
        e.preventDefault();

        // handle active state of navigation column
        $(this).parent().parent().find('.navigation-column.active').removeClass('active');
        $(this).siblings('.navigation-column').addClass('active');

        // enable overlay
        //$overlay.addClass('active');
        //$body.addClass('overflow-hidden');
    });

    $(document).ready(function () {
        // Assuming 'body' is the parent, but ideally you'd use a closer static parent
        $('body').on('DOMNodeInserted', '.w-playbar__time', function () {
            $(this).attr('tabindex', '0');
        });
    });


    $(function () {
        $('.section-banner-carousel').each(function () {

            var siblingSection = $(this).next();

            if (siblingSection && $('.widget-alert.offset-top', $(siblingSection)).length > 0) {
                $(this).addClass('extra-bottom-spacing');
            }
        });
    });
}